import * as React from "react";
const SvgFiRrCloudMoonRain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-moon-rain_svg__a)">
      <path
        fill="#062147"
        d="M18.986 24a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1m-4 0a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1m-4 0a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1M8 22.487a1 1 0 0 1-.6-.2 3.46 3.46 0 0 1-1.28-1.882 3.5 3.5 0 0 1 2-4.143 6.4 6.4 0 0 1 .056-2.732 6 6 0 0 1 11.367-.855c.136.326.287.36.588.427l.175.042a5.04 5.04 0 0 1 2.442 8.156 1.002 1.002 0 1 1-1.5-1.328c.324-.362.553-.8.664-1.272a3.023 3.023 0 0 0-2.133-3.621 2.64 2.64 0 0 1-2.079-1.633 4 4 0 0 0-7.613 2.354 2.015 2.015 0 0 1-1.18 2.3 1.494 1.494 0 0 0-.85 1.8c.086.315.277.593.54.786a1 1 0 0 1-.6 1.8zM4.5 17a1 1 0 0 1-.577-.184A9.3 9.3 0 0 1 .051 8.272 9.35 9.35 0 0 1 7.78.117c1.29-.2 2.606-.146 3.875.159A2.122 2.122 0 0 1 12.6 3.87a8.03 8.03 0 0 0-2.539 4.283 1 1 0 0 1-1.976-.306 9.8 9.8 0 0 1 3.146-5.435.09.09 0 0 0 .024-.1.12.12 0 0 0-.086-.092 8.1 8.1 0 0 0-3.073-.122 7.32 7.32 0 0 0-6.056 6.38 7.2 7.2 0 0 0 3.033 6.706A1 1 0 0 1 4.5 17M19 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-4 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m6 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-moon-rain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudMoonRain;
